import { apiHelper, getApiBaseUrl } from '../utils/apiHelper';

// const API_URL = `${process.env.REACT_APP_API_URL}/api/org/product`;
const API_URL = `${getApiBaseUrl()}/api/org`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchSubCategoryProducts = (payload) => apiHelper(`${API_URL}/sub-category-products`, 'POST', payload, headers);
